module.exports = __webpack_public_path__ + "assets/images/slope-aging/desktop.svg?v=e704c976";